export default "__VITE_ASSET__Ba02UCnO__"